// src/hooks/useResumoPlanosAcao.js
import { useEffect, useState } from 'react';
import { EVENTO_PLANOS_ALTERADOS, resumoPlanosAcao } from '../infra/api/PlanosAcao';

const INTERVALO_MS = 60_000;

/**
 * `{ abertas, vencidas }` do plano de ações, sempre atual: busca ao montar, a cada
 * minuto, quando a aba volta ao foco e na hora em que alguém cria/conclui uma ação
 * (evento da API). `ativo = false` não faz nenhuma chamada (conta sem /acoes no menu).
 */
export default function useResumoPlanosAcao(ativo = true) {
    const [resumo, setResumo] = useState(null);

    useEffect(() => {
        if (!ativo) {
            setResumo(null);
            return undefined;
        }
        let vivo = true;
        const carregar = () =>
            resumoPlanosAcao()
                .then((r) => vivo && setResumo(r))
                .catch(() => {
                    /* contador é acessório: falha silenciosa, tenta no próximo ciclo */
                });
        carregar();
        const id = setInterval(carregar, INTERVALO_MS);
        const aoVoltar = () => document.visibilityState === 'visible' && carregar();
        window.addEventListener(EVENTO_PLANOS_ALTERADOS, carregar);
        document.addEventListener('visibilitychange', aoVoltar);
        return () => {
            vivo = false;
            clearInterval(id);
            window.removeEventListener(EVENTO_PLANOS_ALTERADOS, carregar);
            document.removeEventListener('visibilitychange', aoVoltar);
        };
    }, [ativo]);

    return resumo;
}
